module.exports = __webpack_public_path__ + "img/07 - Condominio_das_Americas_CampoFutebol.5a76b4b7.jpg";